import { useState } from "react";
import { Alert, Form, Input, Modal } from "antd";
import { createOrganization } from "../../utils";

interface Props {
  open: boolean;
  onClose(created?: Organization): void;
}

const CreateOrganizationModal: React.FC<Props> = ({ open, onClose }) => {
  const [form] = Form.useForm<{ name: string }>();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async ({ name }: { name: string }) => {
    setSubmitting(true);
    setError(null);
    try {
      onClose(await createOrganization(name));
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Create organization"
      open={open}
      onCancel={() => onClose()}
      onOk={() => form.submit()}
      okText="Create"
      confirmLoading={submitting}
      destroyOnHidden
      afterClose={() => {
        form.resetFields();
        setError(null);
      }}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, whitespace: true, message: "Enter a name" }]}
        >
          <Input />
        </Form.Item>
        {error && <Alert type="error" title={error} />}
      </Form>
    </Modal>
  );
};

export default CreateOrganizationModal;
